enum ThemePreference {
  DARK = "dark",
  LIGHT = "light",
}

type ThemePreferences = ThemePreference | string;

export { ThemePreference };
export type { ThemePreferences };
